export enum SortingDirection {
    ASCENDING = "ASCENDING",
    DESCENDING = "DESCENDING"
}
